import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaCalendarAlt } from "react-icons/fa";
import { toast } from "react-toastify";
import styles from "./ProviderDashboard.module.css";
import { launchTherapistWaitingRoom, shouldShowTherapistJoinButton } from "../../utils/therapistSessionJoin";

const TodayScheduleCard = ({
  appointments = [],
  dateLabel = "",
  isLoading = false,
}) => {
  const navigate = useNavigate();
  const [joiningSessionId, setJoiningSessionId] = useState(null);

  const handleJoinSession = async (appointment) => {
    setJoiningSessionId(appointment.id);

    try {
      const opened = launchTherapistWaitingRoom(appointment, navigate);
      if (!opened) {
        toast.error("Unable to open the session waiting room.");
      }
    } finally {
      setJoiningSessionId(null);
    }
  };

  const hasAppointments = appointments.length > 0;

  return (
    <section className={styles.widget}>
      <div className={styles.widgetHeader}>
        <div className={styles.widgetTitleGroup}>
          <FaCalendarAlt className={styles.widgetIcon} aria-hidden />
          <h2 className={styles.widgetTitle}>Today&apos;s Schedule</h2>
        </div>
        {dateLabel ? <p className={styles.widgetDate}>{dateLabel}</p> : null}
      </div>

      <div className={styles.widgetBody}>
        {isLoading ? (
          <p className={styles.loadingState}>Loading schedule...</p>
        ) : hasAppointments ? (
          appointments.map((appointment) => (
            <div className={styles.scheduleCard} key={appointment.id}>
              <span className={styles.avatar}>{appointment.initials}</span>
              <div className={styles.cardContent}>
                <p className={styles.patientName}>{appointment.patientName}</p>
                <p className={styles.cardMeta}>
                  {appointment.appointmentTime} · {appointment.sessionType}
                </p>
              </div>
              {shouldShowTherapistJoinButton(appointment) ? (
                <button
                  type="button"
                  className={styles.joinBtn}
                  disabled={joiningSessionId === appointment.id}
                  onClick={() => handleJoinSession(appointment)}
                >
                  {joiningSessionId === appointment.id ? "Opening..." : "Join"}
                </button>
              ) : null}
            </div>
          ))
        ) : (
          <div className={styles.scheduleEmptyState}>
            <p className={styles.emptyStateMessage}>
              No sessions scheduled for today.
            </p>
            <button
              type="button"
              className={styles.emptyStateAction}
              onClick={() => navigate("/appointments")}
            >
              View Schedule
            </button>
          </div>
        )}
      </div>

      <div className={styles.widgetFooter}>
        <button
          type="button"
          className={styles.ctaLink}
          onClick={() => navigate("/appointments")}
        >
          View Full Schedule
          <span className={styles.ctaArrow}>→</span>
        </button>
      </div>
    </section>
  );
};

export default TodayScheduleCard;
